import {
  LOC_FOUND,
  LOC_DENIED,
  SAVE_SELECTED_SERVICES,
  GET_CATEGORIES_SUCCESS,
  BOOK_APPOINTMENT_SUCCESS,
  FIND_AVAILABLE_SLOTS_SUCCESS,
  SET_USER_ADDRESS,
} from "../constants";
import {
  getItemFromSessionStorage,
  setItemInSessionStorage,
} from "../../utils";

const initialState = {
  locFound: "",
  selectedServices: getItemFromSessionStorage("selectedSerivces") || [],
  bookingSuccess: false,
  availableSlots: [],
  userAddresses: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOC_FOUND:
      return { ...state, locFound: "fetched" };
    case LOC_DENIED:
      return { ...state, locFound: "denied" };
    case GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        selectedServices: [],
      };
    case SAVE_SELECTED_SERVICES:
      setItemInSessionStorage("selectedSerivces", action.selectedServices);
      return {
        ...state,
        selectedServices: action.selectedServices,
        bookingSuccess: false,
        availableSlots: [],
      };
    case BOOK_APPOINTMENT_SUCCESS: {
      return {
        ...state,
        bookingSuccess: true,
      };
    }
    case FIND_AVAILABLE_SLOTS_SUCCESS: {
      return {
        ...state,
        availableSlots: action.data,
      };
    }
    case SET_USER_ADDRESS: {
      return {
        ...state,
        userAddresses: action.data,
      };
    }
    default:
      return state;
  }
};

export default reducer;
